import Row from '@components/Row';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { Link } from '@stackflow/link';

import useSelectShop from './hooks/useSelectShop';

function ShopSelector() {
    const { displayName, isVisible } = useSelectShop();
    if (isVisible) {
        return (
            <Row fullWidth justify='center' align='center'>
                <Link activityName='StampScopeBottomSheet'
                    activityParams={{}}>
                    <Button>
                        {displayName}
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3 5L8 10L13 5" stroke="#504A46" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </Button>
                </Link>
            </Row>
        );
    }
    return null;
}

const Button = styled.button`
    padding: 8px 16px;
    background-color: ${colors.surfaceDisabled};
    font-size: 14px;
    font-weight: bold;
    color: ${colors.textSecondary};
    border-radius: 100px;
    display: flex;
    gap: 8px;
`;

export default ShopSelector;
